module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"actions.drag.drop":"Ou la glisser directement dans cette zone.","actions.reset":"Réinitialiser","actions.select":"Sélectionner une image"}}')
  delete Component.options._Ctor
}
